import { useState } from "react";
import {
  Box,
  Button,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  SelectChangeEvent,
  TextField,
} from "@mui/material";
import ArrowForward from "@mui/icons-material/ArrowForward";
import { handleApplyFilterItemFunction } from "./FiltersContainer";
import { IOptionSchema, OperatorEnum } from "../../../../utils/types";
import { useNotificationContext } from "../../../../context/notificationContext";

interface TextFilterProps {
  handleApplyFilter: handleApplyFilterItemFunction;
  value: string;
  columnName: string;
  operator: string;
}

const operatorOptions: IOptionSchema[] = [
  { value: OperatorEnum.IS_EQUAL, label: "مساوی" },
  { value: OperatorEnum.IS_EQUAL_TO_OR_NULL, label: "مساوی یا خالی" },
  { value: OperatorEnum.IS_NULL, label: "خالی" },
  { value: OperatorEnum.IS_NOT_EQUAL_TO, label: "نامساوی" },
  { value: OperatorEnum.IS_NOT_NULL, label: "خالی نباشد" },
  { value: OperatorEnum.CONTAINS, label: "شامل" },
];

const TextFilter = ({
  handleApplyFilter,
  value,
  columnName,
  operator: operatorValue,
}: TextFilterProps) => {
  const { setNotification } = useNotificationContext();
  const defaultOperator = operatorOptions.find(
    (opt) => opt.value === operatorValue
  );
  const [inputValue, setInputValue] = useState<string>(value);
  const [operator, setOperator] = useState<string>(
    defaultOperator?.value || operatorOptions[0].value
  );

  const applyHandler = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    if (inputValue?.trim()) {
      handleApplyFilter(columnName, operator, inputValue.trim());
    } else {
      setNotification({
        message: "لطفا مقدار فیلتر را وارد نمایید",
        type: "error",
      });
    }
  };

  const inputChangeHandler = (event: React.ChangeEvent<HTMLInputElement>) => {
    setInputValue(event.target.value);
  };

  const selectOperatorHandler = (event: SelectChangeEvent<string>) => {
    setOperator(event.target.value);
  };

  return (
    <form onSubmit={applyHandler}>
      <Box display="flex" flexDirection="column" gap={2}>
        <FormControl fullWidth size="small" dir="rtl">
          <InputLabel id="operator-label">عملگر</InputLabel>
          <Select
            labelId="operator-label"
            value={operator}
            label="عملگر"
            onChange={selectOperatorHandler}
            MenuProps={{
              PaperProps: {
                sx: {
                  textAlign: "right",
                  direction: "rtl",
                },
              },
            }}
          >
            {operatorOptions.map((opt) => (
              <MenuItem key={opt.value} value={opt.value}>
                {opt.label}
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        <Box display="flex" alignItems="center" gap={2}>
          <ArrowForward sx={{ transform: "rotate(180deg)", color: "gray" }} />
          <TextField
            dir="rtl"
            fullWidth
            size="small"
            value={inputValue}
            onChange={inputChangeHandler}
            placeholder="وارد نمایید"
            label="مقدار"
          />
        </Box>

        <Button
          type="submit"
          variant="contained"
          color="primary"
          fullWidth
          sx={{ alignSelf: "flex-start", height: 36 }}
        >
          تایید
        </Button>
      </Box>
    </form>
  );
};

export default TextFilter;
